import React from 'react';
export const Terms = () => {
  return <div className="bg-white" data-id="element-668">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-669">
        <div className="text-center" data-id="element-670">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-671">
            Terms & Conditions
          </h1>
          <p className="mt-4 text-xl text-gray-500 max-w-3xl mx-auto" data-id="element-672">
            The terms and conditions governing the use of our services.
          </p>
        </div>
        <div className="mt-12 max-w-4xl mx-auto" data-id="element-673">
          <div className="prose prose-rose max-w-none" data-id="element-674">
            <h2 data-id="element-675">Overview</h2>
            <p data-id="element-676">
              This website (suretask.it.com) is operated by Suretask. Throughout
              this site, the terms "we," "us," and "our" refer to Suretask.
              Suretask provides this website, including all content, tools, and
              services, subject to your acceptance of these terms, conditions,
              policies, and notices. These Terms govern your use of the Suretask
              website and your purchase of service plans.
            </p>
            <h3 data-id="element-677">Company Information</h3>
            <p data-id="element-678">
              Suretask
              <br data-id="element-679" />
              18 Cambridge Rd, Ilford IG3 8LU
              <br data-id="element-680" />
              Email: manishkisan879@gmail.com
              <br data-id="element-681" />
              Phone: 0800 055 4969
            </p>
            <h3 data-id="element-682">Service Overview</h3>
            <p data-id="element-683">
              Suretask offers appliance repair and maintenance cover plans. Each
              plan entitles customers to unlimited repairs on covered appliances
              during the subscription period. Full details of each plan,
              including pricing, duration, and inclusions, are clearly available
              on our product and checkout pages.
            </p>
            <h3 data-id="element-684">Pricing and Currency</h3>
            <p data-id="element-685">
              All prices are in GBP (£ - British Pounds Sterling) and all
              charges are processed in GBP. Payments are securely accepted via
              Visa, Mastercard, and other major debit and credit cards.
            </p>
            <h3 data-id="element-686">Order Confirmation</h3>
            <p data-id="element-687">
              After completing your purchase, you'll receive an email
              confirmation. If you don't receive this within one hour, please
              contact manishkisan879@gmail.com.
            </p>
            <h3 data-id="element-688">Dispute Resolution</h3>
            <p data-id="element-689">
              If you have concerns about your service plan or charges, please
              contact us directly:
            </p>
            <ul data-id="element-690">
              <li data-id="element-691">Email: manishkisan879@gmail.com</li>
              <li data-id="element-692">Phone: 0800 055 4969</li>
            </ul>
            <p data-id="element-693">
              We aim to resolve disputes promptly and fairly, with a focus on
              excellent customer service.
            </p>
            <h3 data-id="element-694">Modifications</h3>
            <p data-id="element-695">
              We may revise these Terms from time to time. Continued use of our
              site or services after changes means you accept the updated Terms.
            </p>
            <h3 data-id="element-696">Service Plans</h3>
            <p data-id="element-697">
              Our plans cover repair and maintenance for selected appliances.
              Detailed plan information is available on each product page.
            </p>
            <h3 data-id="element-698">Payments</h3>
            <p data-id="element-699">
              We accept secure card payments and Direct Debit. You must be
              authorized to use your chosen payment method.
            </p>
            <h3 data-id="element-700">Cancellation & Refund</h3>
            <p data-id="element-701">
              You can cancel within 14 days of purchase for a full refund.
              Partial refunds may be considered up to 28 days at our discretion,
              depending on whether any services have been provided. After 28
              days, refunds will no longer be available.
            </p>
            <h3 data-id="element-702">Liability</h3>
            <p data-id="element-703">
              We are not responsible for losses or damages caused by misuse of
              appliances or systems, or from circumstances beyond our reasonable
              control.
            </p>
            <h3 data-id="element-704">Contact Us & Dispute Resolution</h3>
            <p data-id="element-705">For any issues, contact:</p>
            <ul data-id="element-706">
              <li data-id="element-707">Email: manishkisan879@gmail.com</li>
              <li data-id="element-708">Phone: 0800 055 4969</li>
            </ul>
            <p data-id="element-709">We will reply during business hours.</p>
            <h3 data-id="element-710">Prohibited Use & Plan Exclusions</h3>
            <p data-id="element-711">
              To maintain fair use and service quality, the following are
              excluded from all plans:
            </p>
            <ul data-id="element-712">
              <li data-id="element-713">Faults or damage existing before plan activation.</li>
              <li data-id="element-714">Damage caused by misuse, neglect, or tampering.</li>
              <li data-id="element-715">
                Repairs unrelated to normal appliance function (e.g., cosmetic
                damage).
              </li>
              <li data-id="element-716">Illegal or fraudulent use of our services or website.</li>
              <li data-id="element-717">Appliances not used according to manufacturer guidelines.</li>
            </ul>
            <p data-id="element-718">
              If any of these apply, your plan may be cancelled without refund
              or support.
            </p>
            <h3 data-id="element-719">Dispute Resolution (Emphasis)</h3>
            <p data-id="element-720">
              If you have an issue with your service or purchase, please contact
              us first before raising a chargeback with your bank:
            </p>
            <ul data-id="element-721">
              <li data-id="element-722">Email: manishkisan879@gmail.com</li>
              <li data-id="element-723">Phone: 0800 055 4969</li>
            </ul>
            <p data-id="element-724">
              We strive to resolve disputes quickly and fairly. Please avoid
              raising chargebacks before speaking with us—we want to help.
            </p>
            <h3 data-id="element-725">Refunds</h3>
            <p data-id="element-726">
              Refunds will be returned to your original payment method. Allow
              5–10 working days for processing depending on your provider.
            </p>
            <h3 data-id="element-727">Terms Acceptance</h3>
            <p data-id="element-728">
              By using our site or purchasing services, you agree to these Terms
              of Service ("Terms"). They apply to all users including browsers,
              customers, vendors, and content contributors. If you don't agree
              to these Terms, please do not use the website or services.
            </p>
            <h3 data-id="element-729">New Features</h3>
            <p data-id="element-730">
              Any new tools or features added will also be subject to these
              Terms.
            </p>
          </div>
        </div>
      </div>
    </div>;
};